import { tsValidateNumber, tsValidateOptionalId } from '@nu-art/ts-common';
export const StoreItem_validator = {
    storeId: tsValidateOptionalId,
};
export const ShopifyItem_validator = {
    ...StoreItem_validator,
    blob: undefined,
    storeId: tsValidateOptionalId,
    shopifyId: tsValidateNumber(),
    syncTimestamp: tsValidateNumber(),
};
//# sourceMappingURL=types.js.map